import Icon from '../Icon.vue'

Icon.register({
  'zoom_in': {
    width: 17,
    height: 16,
    paths: [
      {
        d: 'M9.296 7.893a3.82 3.82 0 01-1.404 1.404A3.77 3.77 0 016 9.819 3.823 3.823 0 012.182 6 3.823 3.823 0 016 2.182 3.823 3.823 0 019.818 6c0 .692-.199 1.333-.522 1.893zm6.411 6.4l-4.822-4.821A5.964 5.964 0 0012 6c0-3.307-2.692-6-6-6S0 2.693 0 6c0 3.308 2.692 6 6 6a5.958 5.958 0 003.47-1.115l4.823 4.822A.993.993 0 0015 16a.999.999 0 00.707-1.707z'
      },
      {
        d: 'M8 5H7V4a1 1 0 10-2 0v1H4a1 1 0 100 2h1v1a1 1 0 102 0V7h1a1 1 0 100-2z'
      }
    ]
  }
})
